<div class="container">
  @if (type() === "increase") {
  <div class="input_title">Increase price by</div>
  <div class="container__box container__box--red">
    <div class="container__box__input">
      <input
        type="text"
        placeholder="Increase by"
        [(ngModel)]="percentageValue"
      />
    </div>
    <div class="container__box__button" (click)="submitIncrease()">
      <svg class="navigation__icon">
        <use xlink:href="images/sprites5.svg#icon-level-up"></use>
      </svg>
    </div>
  </div>
  }@else{
  <div class="input_title">Decrease price By</div>
  <div class="container__box container__box--green">
    <div class="container__box__input">
      <input
        type="text"
        placeholder="Decrease by"
        [(ngModel)]="percentageValue"
      />
    </div>
    <div class="container__box__button" (click)="submitDecrease()">
      <svg class="navigation__icon">
        <use xlink:href="images/sprites5.svg#icon-level-down"></use>
      </svg>
    </div>
  </div>
  }
</div>
